<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>门店管理</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
                    <el-form-item label="门店名称" prop="storeName">
                        <el-input v-model="queryParams.storeName" placeholder="请输入门店名称"></el-input>
                    </el-form-item>
                    <el-form-item label="门店类型" prop="isSelfSupport">
                        <el-select v-model="queryParams.isSelfSupport" placeholder="请输入门店类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="直营" value="Y"></el-option>
                            <el-option label="非直营" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所在城市" prop="storeCity">
                        <el-input v-model="queryParams.storeCity" placeholder="请输入所在城市"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getStoreList">查询</el-button>
                        <el-button @click="resetForm('queryParams')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <span class="tabTitle">门店列表</span>
                    <el-button type="primary" @click="showDialog('1')">新增</el-button>
                </div>
                <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="storeName" align="center" label="门店名称" />
                    <el-table-column prop="storeCity" align="center" label="所在城市">
                        <template slot-scope="scope">
                            {{(scope.row.storeCity || '').replace(/,/g,'')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeAddress" align="center" label="门店地址" />
                    <el-table-column prop="contacts" align="center" label="联系人" />
                    <!-- <el-table-column prop="test" align="center" label="管理门店">
                    <template slot-scope="scope">
                        <el-link type="primary">查看详情<i class="el-icon-view el-icon--right"></i> </el-link>
                    </template>
                </el-table-column> -->
                    <el-table-column prop="contactPhone" align="center" label="联系电话" />
                    <el-table-column prop="businessHours" align="center" label="营业时间">
                        <template slot-scope="scope">
                            {{scope.row.startBusinessHours}} ~ {{scope.row.endBusinessHours}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="isSelfSupport" align="center" label="门店类型">
                        <template slot-scope="scope">
                            {{scope.row.isSelfSupport == 'Y' ? '直营':'非主营'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="test" align="center" label="启用状态">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.storeStatus" active-value="0" inactive-value="1" active-color="#13ce66" inactive-color="#DCDFE6" @change="setStoreState(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">配置角色</el-button> -->
                            <el-button size="mini" type="success" @click="showDialog('2',scope.row)">编辑</el-button>
                            <el-button size="mini" type="primary" @click="onLookQrcode(scope.row)">查看二维码</el-button>
                            <!-- <el-button size="mini" type="danger" @click="delTabItem(scope.$index, scope.row)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
            </el-card>
        </div>
        <my-from-dialog :isShow="isShow" :title="dialogTitle" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :isFullscreen="true" :scrollHeight="''" :dialogWidth="'500px'" :okBtnText="'保 存'">
            <template slot="froms">
                <el-form :model="form" :rules="rules" ref="form" label-width="120px">
                    <el-form-item label="所属药企" prop="enterpriseName">
                        <el-select v-model="form.enterpriseName" placeholder="请选择所属药企" @change="getEnterpriseId" disabled class="baseInp">
                            <el-option v-for="(item,index) in enterpriseList" :key="index" :label="item.enterpriseName" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="门店名称" prop="storeName">
                        <el-input v-model="form.storeName" placeholder="请输入门店名称" class="baseInp"></el-input>
                    </el-form-item>
                    <!-- <el-form-item class="display: none;">
                        <template slot="label"><span class="xh"></span>门店地址</template>
                        <AreaSelectPicker ref="areaSelectPicker" class="input-all" :preSelectItem="preSelectItem" />
                    </el-form-item> -->
                    <el-form-item label="门店地址" prop="areaList">
                        <areaPicker :areaList="areaList" @getAreaData="getAreaData" class="baseInp" />
                    </el-form-item>
                    <el-form-item label="详细地址" prop="storeAddress">
                        <el-input v-model="form.storeAddress" placeholder="请输入详细地址" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="account">
                        <el-input v-model="form.account" placeholder="请输入登录账号" class="baseInp" :disabled="form.id != undefined"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password" v-if="form.id == undefined">
                        <el-input v-model="form.password" placeholder="请输入登录密码,不填默认a123465" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contacts">
                        <el-input v-model="form.contacts" placeholder="请输入联系人" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contactPhone">
                        <el-input v-model="form.contactPhone" placeholder="请输入联系电话" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照">
                        <myUpload @getImgUrl="getImgUrl" :imgUrls="form.businessLicense||''"></myUpload>
                        <!-- <el-input v-model="form.value" placeholder="请输入联系电话" class="baseInp"></el-input> -->
                    </el-form-item>
                    <el-form-item label="药品销售许可证">
                        <myUpload @getImgUrl="getImgUrl2" :imgUrls="form.saleLicense||''"></myUpload>
                    </el-form-item>
                    <el-form-item label="药店类型" prop="isSelfSupport">
                        <el-radio-group v-model="form.isSelfSupport" size="mini">
                            <el-radio label="Y">直营</el-radio>
                            <el-radio label="N">非直营</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否24小时营业">
                        <el-radio-group v-model="form.is24hours" size="mini">
                            <el-radio label="Y">是</el-radio>
                            <el-radio label="N">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-radio-group v-model="form.storeStatus" size="mini">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">停用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="营业时间">
                        <!-- businessHours -->
                        <!-- <el-date-picker v-model="form.date1" type="date" placeholder="选择开始日期" /> 至
                        <el-date-picker v-model="form.date2" type="date" placeholder="选择结束日期" /> -->
                        <el-time-select placeholder="开始" v-model="date1" :picker-options="{start: '00:00',step: '00:01',end: '23:59'}" class="smallInp" /> 至
                        <el-time-select placeholder="结束" v-model="date2" :picker-options="{start: '00:00',step: '00:01',end: '23:59'}" class="smallInp" />
                        <!-- <el-time-select placeholder="开始" v-model="form.startBusinessHours" :picker-options="{start: '00:00',step: '00:15',end: '23:59'}" class="smallInp" /> 至 -->
                        <!-- <el-time-select placeholder="结束" v-model="form.endBusinessHours" :picker-options="{start: '00:00',step: '00:15',end: '23:59'}" class="smallInp" /> -->
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="form.storeRemarks" :rows="5" type="textarea" class="baseInp"></el-input>
                    </el-form-item>
                </el-form>
            </template>
        </my-from-dialog>
        <!-- 生成二维码弹出框 -->
        <el-dialog title="二维码下载" center :visible.sync="showQrcode" width="1100px" top="5vh">
            <download-qrcode :qrCodeForm="qrCodeForm" :showQrcode="showQrcode" />
        </el-dialog>
    </div>
</template>

<script>
let self = null;
import myFromDialog from '@/components/common/from_dialog';
import myUpload from '@/components/common/upload';
import downloadQrcode from '@/components/common/downloadQrcode';
// import AreaSelectPicker from '@/components/common/AreaSelect';
import { objDeepCopy } from '@/utils/index';
import areaPicker from '@/components/common/form/area_picker.vue';

export default {
    components: {
        myFromDialog,
        downloadQrcode,
        myUpload,
        // AreaSelectPicker,
        areaPicker
    },
    computed: {},
    watch: {},
    data() {
        return {

            isShow: false,
            visible: false,
            dialogTitle: '新增门店',
            qrCodeForm: {
                enterpriseId: '',
                storeId: ''
            },
            showQrcode: false,
            dialogType: '1',
            pageNum: 1,
            pageSize: 10,
            totalCount: 0,
            tableData: [],
            enterpriseList: [],
            queryParams: {
                storeName: '',
                isSelfSupport: '',
                storeCity: '',
                value: ''
            },
            form: {
                value: '',
                radioVal: '1'
            },
            date1: '',
            date2: '',
            preSelectItem: {
                province: '',
                city: '',
                area: '',
                areaCode: ''
            },
            loginData: {},
            areaList: [],
            rules: this.getRules()
        };
    },
    created() {
        self = this;
        this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
        this.getStoreList();
        this.getEnterpriseList();
    },
    methods: {
        onLookQrcode(row) {
            this.qrCodeForm.enterpriseId = row.enterpriseId;
            this.qrCodeForm.storeId = row.id;
            this.showQrcode = true;
        },
        onQrcodeClose() {
            this.showQrcode = false;
        },
        getEnterpriseId(item) {
            this.form.enterpriseName = item.enterpriseName;
            this.form.enterpriseId = item.id;
            // console.log(item);
        },
        getImgUrl(url) {
            console.log(url);
            this.form.businessLicense = url;
        },
        getImgUrl2(url) {
            console.log(url);
            this.form.saleLicense = url;
        },
        closeDialog(data) {
            this.isShow = false;
            console.log(data);
        },
        okDialog(data) {
            console.log(data);
            // this.isShow = false;
            if (this.dialogType == '1') {
                this.addStore();
            } else if (this.dialogType == '2') {
                this.editStore();
            }
            // this.isShow = false;
        },
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },

        // 当前显示条数
        barSizeChange(val) {
            this.pageSize = val;
            this.getStoreList();
        },
        // 当前页
        barCurrentChange(val) {
            this.pageNum = val;
            this.getStoreList();
        },
        getCheckedNodes() {
            console.log(this.$refs.tree.getCheckedNodes());
        },
        delTabItem() {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 初始化弹窗列表
        initForm(item) {
            let _this = this;
            this.form = {};
            this.date1 = '';
            this.date2 = '';
            this.preSelectItem = this.$set({ province: '', city: '', area: '', areaCode: '' });
            this.areaList = [];
            this.enterpriseList.map((d, i) => {
                if (d.id == _this.loginData.enterpriseId) {
                    this.form.enterpriseName = d.enterpriseName;
                    this.form.enterpriseId = d.id;
                }
            });
            if (item) {
                this.areaList = [item.province, item.city, item.area];
                let storeCity = item.storeCity.split(',') || [];
                // let businessHours = item.businessHours.split('~');
                this.form = objDeepCopy(item);
                this.form.enterpriseName = item.enterpriseName;
                this.preSelectItem = { province: storeCity[0] || '', city: storeCity[1] || '', area: storeCity[2] || '', areaCode: '' };
                // this.form.date1 = '06:45';
                // this.date1 = businessHours[0] || '';
                // this.date2 = businessHours[1] || '';
                this.date1 = item.startBusinessHours;
                this.date2 = item.endBusinessHours;
            } else {
            }
        },
        // 显示弹窗
        showDialog(dialogType, item) {
            let _this = this;
            this.dialogType = dialogType;
            this.dialogTitle = dialogType == '1' ? '新增门店' : '编辑门店';
            this.isShow = true;
            this.$nextTick(() => {
                _this.$refs.form.clearValidate();
                // _this.$refs.areaSelectPicker.$refs.areas.clearValidate();
            })
            this.initForm(item);
            // if (dialogType == '2') { // 编辑

            // } else {

            // }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.getStoreList();
        },
        // 获取门店列表
        getStoreList() {
            let _this = this;
            let queryParams = this.queryParams;
            let params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                storeName: queryParams.storeName,
                enterpriseId: this.loginData.enterpriseId,
                isSelfSupport: queryParams.isSelfSupport,
                storeCity: queryParams.storeCity
            };
            this.$https.get('system/store/list', params).then(res => {
                console.log(res);
                _this.tableData = res.rows || [];
                _this.totalCount = res.total;
            }).catch(res => {

            });
        },
        // 获取药企列表
        getEnterpriseList() {
            let _this = this;
            this.$https.get('system/enterprise/findAll', {}).then(res => {
                console.log(res);
                _this.enterpriseList = res.data || [];
            }).catch(res => {

            });
        },
        setParams(cb) {
            // const { province, city, area, areaCode } = this.$refs.areaSelectPicker.selectItem;
            // console.log(this.$refs.areaSelectPicker);
            // this.form.storeCity = province + ',' + city + ',' + area;
            // this.form.businessHours = (this.date1 || '') + '~' + (this.date2 || '');
            this.form.startBusinessHours = this.date1 || '';
            this.form.endBusinessHours = this.date2 || '';
            console.log(this.form);
            // let flag = this.$refs.areaSelectPicker.validateForm();
            let flag2 = false;
            this.$refs.form.validate(valid => {
                flag2 = valid;
                // return valid;
                console.log(flag2);
                if (flag2) {
                    cb && cb(true)
                    // return true;
                } else {
                    this.$message.error('提交信息不完整，请检查');
                    cb && cb(false)
                }
            });
            console.log(flag2);
        },
        // 新增
        addStore() {
            let _this = this;
            let bool = this.setParams((flag) => {
                if (flag) {
                    this.$https
                        .post('system/store', this.form)
                        .then(res => {
                            console.log(res);
                            // _this.tableData = res.rows || [];
                            _this.isShow = false;
                            _this.$message.success('新增成功');
                            _this.getStoreList();
                        })
                        .catch(res => {

                        });
                }
            });
            // if (!bool) return;
        },
        // 编辑
        editStore() {
            let _this = this;
            let bool = this.setParams((flag) => {
                if (flag) {
                    this.$https
                        .put('system/store', this.form)
                        .then(res => {
                            console.log(res);
                            // _this.tableData = res.rows || [];
                            _this.isShow = false;
                            _this.$message.success('编辑成功');
                            _this.getStoreList();
                        })
                        .catch(res => {

                        });
                }
            });
            // if (!bool) return;
        },

        // 修改门店状态
        setStoreState(item) {
            let _this = this;
            let params = { id: item.id, storeStatus: item.storeStatus };
            this.$https
                .put('system/store/changeStatus', params)
                .then(res => {
                    console.log(res);
                    // _this.tableData = res.rows || [];
                    _this.$message.success('状态修改成功');
                    // _this.getStoreList();
                    // _this.isShow = false;
                    _this.getStoreList();
                })
                .catch(res => {

                });
        },
        getRules() {
            return {
                enterpriseName: { required: true, message: '请选择所属药企', trigger: 'blur' },
                storeName: { required: true, message: '请输入门店名称', trigger: 'blur' },
                storeAddress: { required: true, message: '请输入门店地址及门店详细地址', trigger: 'blur' },
                isSelfSupport: { required: true, message: '请选择门店类型', trigger: 'blur' },
                contacts: { required: true, message: '请输入联系人', trigger: 'blur' },
                contactPhone: { required: true, message: '请输入联系电话', trigger: 'blur' },
                account: { required: true, message: '请输入登录账号', trigger: 'blur' },
                password: { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' },
                areaList: [
                    {
                        required: true,
                        validator: function (rule, value, callback) {
                            setTimeout(() => {
                                if (self.areaList.length > 0) {
                                    callback();
                                } else {
                                    callback('请选择地址');
                                }
                            }, 300)
                        }
                    }
                ],
            };
        },
        renderFormData(data) { //渲染表单页面
            if (data.province && data.area) {
                if (data.city) {
                    self.areaList = [data.province, data.city, data.area];
                } else {
                    self.areaList = [data.province, data.area];
                }
            }
        },
        initAreaForm() { // 初始化表单省市区
            this.form.province = '';
            this.form.city = '';
            this.form.area = '';
        },
        getAreaData(item) { // 获取省市区 length=3 省市区 length=2 省区
            console.log(item);
            this.areaList = item.codes;
            this.initAreaForm();
            if (item.codes.length === 3) {
                this.form.province = item.codes[0];
                this.form.city = item.codes[1];
                this.form.area = item.codes[2];
                this.form.storeCity = item.names[0] + ',' + item.names[1] + ',' + item.names[2];
            } else {
                this.form.province = item.codes[0];
                this.form.area = item.codes[1];
                this.form.storeCity = item.names[0] + ',' + item.names[1];
            }
            console.log(this.form);
        },
    }
};
</script>

<style lang="less" scoped>
// .wrap {
//     background: red;
//     span {
//         color: blue;
//     }
// }

.wrap {
    // background: #fff;
}
.boxCard {
    margin-bottom: 20px;
}
.queryBox {
    // background: #fff;
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.dlRole {
    margin-bottom: 10px;
    span {
        color: red;
    }
}

.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}

.smallInp {
    width: 100px;
}
.xh:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
</style>
